import { combineReducers } from "redux";
import settings from "./settings/reducer";
import menu from "../store/slices/menuSlice";
import dashboardFilters from "../store/slices/dashboardFiltersSlice";
import auth from "./auth/authSlice";
import authUser from "./auth/reducer";

import { dashboardApi } from "../store/api/dashboardApi";
import { authApi } from "../store/api/authApi";
import { userApi } from "../store/api/userApi";
import { recordingApi } from "../store/api/recordingApi";
import { clientApi } from "../store/api/clientApi";
import { clientSchemaApi } from "../store/api/clientSchemaApi";
import { adminApi } from "../store/api/adminApi";
import { externalApi as externalApiRTK } from "../store/api/externalApi";
import { reportApi } from "../store/api/reportApi";
import { reportsApi } from "../store/api/reportsApi";

const reducers = combineReducers({
  menu,
  settings,
  dashboardFilters,
  auth,
  authUser,

  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [recordingApi.reducerPath]: recordingApi.reducer,
  [clientApi.reducerPath]: clientApi.reducer,
  [clientSchemaApi.reducerPath]: clientSchemaApi.reducer,
  [adminApi.reducerPath]: adminApi.reducer,
  [externalApiRTK.reducerPath]: externalApiRTK.reducer,
  [reportApi.reducerPath]: reportApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
});

export default reducers;
